export default __webpack_public_path__ + "static/media/2355.d9c71d17.png";